import { NgModule, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import EN_CA from '../assets/i18n/en-CA.json';
import ES_CO from '../assets/i18n/es-CO.json';
import ES_MX from '../assets/i18n/es-MX.json';
import FR_CA from '../assets/i18n/fr-CA.json';
import PT_PT from '../assets/i18n/pt-PT.json';

@NgModule({})
export class SharedComponentsTranslateModule {
  constructor(@Optional() translateService: TranslateService) {
    if (!translateService) {
      return;
    }
    // Pre-compile translations with TranslateMessageFormatCompiler so that ICU
    // {param} interpolation works regardless of what compiler the host app
    // registered on TranslateService at module-constructor time.
    const compiler = new TranslateMessageFormatCompiler();
    translateService.setTranslation('en-CA', compiler.compileTranslations(EN_CA, 'en-CA'), true);
    translateService.setTranslation('fr-CA', compiler.compileTranslations(FR_CA, 'fr-CA'), true);
    translateService.setTranslation('es-MX', compiler.compileTranslations(ES_MX, 'es-MX'), true);
    translateService.setTranslation('es-CO', compiler.compileTranslations(ES_CO, 'es-CO'), true);
    translateService.setTranslation('pt-PT', compiler.compileTranslations(PT_PT, 'pt-PT'), true);
  }
}
